import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {TrackResolver} from './track-resolver';
import {TrackComponent} from './track.component';
import {RedirectToAdminActivatorGuard} from './redirect-to-admin-activator.guard';

@NgModule({
  imports: [
    RouterModule.forChild([
      {path: 'track/:query', component: TrackComponent, resolve: {shipment: TrackResolver}, runGuardsAndResolvers: 'always', canActivate: [RedirectToAdminActivatorGuard]}
    ])
  ],
  exports: [
    RouterModule
  ]
})
export class TrackRoutingModule {
}
